import React, { useContext, useEffect, useState } from 'react';
import styled from "styled-components";
import { AppContext } from '../../contexts/AppContext';
import { useHistory } from 'react-router';
import useWindowDimensions from '../../helpers/useWindowDimensions';
import Modes from '../../contexts/Modes';

const Wrapper = styled.div`
background-color: ${props => props.colorTheme.backgroundColor};
display:  flex;
flex-direction: row;
overflow-x: hidden;
overflow-y: hidden;
width: 100%;
// margin: 5px;
margin-left: 0px;
margin-right: 0px;
height: 40px;
position: absolute;
top: ${({ height }) => height - 40}px;
`;

const Section = styled.div`
overflow-x: hidden;
overflow-y: hidden;
flex: 1;
text-align: center;
display:  flex;
flex-direction: row;
justify-content: center;
`;

const Line = styled.div`
overflow-x: hidden;
overflow-y: hidden;
text-align: center;
flex: 2;
max-width: 100px;
margin: 10px;
height: 12px;
border-radius: 9.5px;
background-color: ${props => props.colorTheme.footer.lineColor};
`;

const LineActive = styled.div`
overflow-x: hidden;
overflow-y: hidden;
text-align: center;
height: 10px;
flex: 2;
max-width: 100px;
margin: 10px;
height: 12px;
border-radius: 9.5px;
background-color: ${props => props.colorTheme.footer.lineActiveColor};
`;

export function Footer() {

    const { mode, loggedIn, pages, currentPage, currentTheme } = useContext(AppContext);
    const { height, width } = useWindowDimensions();

    return (
        <div>
            {mode === Modes.DRIVER_DASHBOARD && loggedIn &&
                <Wrapper colorTheme={currentTheme.dashboard} height={height}>
                    <Section>
                        {
                            pages.map((page) => {
                                if (page.pageId === currentPage) {
                                    return (<LineActive colorTheme={currentTheme.dashboard} />);
                                } else {
                                    return (<Line colorTheme={currentTheme.dashboard} />);
                                }
                            })
                        }
                    </Section>
                </Wrapper>}
        </div>
    );
}